module.exports = __webpack_public_path__ + "img/HTML5-logo.525f317f.svg";